(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elogbooksUser', ElogbooksUser);

    function ElogbooksUser() {
        return {
            restrict: 'E',
            scope: {
                link: '='
            },
            transclude: true,
            templateUrl: '/modules/directives/links/user/user.html',
            controller: function ($scope, userManager) {

                $scope.type = null;

                switch (true) {
                    case userManager.hasPermission('user_permission_view_users') && typeof $scope.link !== 'undefined':
                        $scope.type = 'admin';
                        break;
                    case true:
                        $scope.type = 'user';
                        break;
                }
            }
        };
    };

})();
